import { Component, OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { environment } from 'src/environments/environment'
import { first } from 'rxjs'
import { AuthService } from 'src/app/common/services/auth.service'
import { StateService } from 'src/app/common/services/state.service'
import { generateUtmUrl } from 'src/app/common/utilities/utm-params-utils'

@Component({
    selector: 'app-bx-header',
    imports: [RouterModule],
    templateUrl: './bx-header.component.html',
    styleUrl: './bx-header.component.scss'
})
export class BxHeaderComponent implements OnInit {
  showProfileDropdown = false
  userName: string | undefined

  constructor (
    private router: Router,
    private authService: AuthService,
    private stateService: StateService
  ) { }

  ngOnInit (): void {
    this.stateService.userDetails.pipe(first()).subscribe((userDetails: any) => {
      if (userDetails?.firstName) {
        this.userName = userDetails.firstName
      }
    })
  }

  profileDropdown () {
    this.showProfileDropdown = !this.showProfileDropdown
  }

  openProfilePage () {
    this.showProfileDropdown = false
    window.location.href = generateUtmUrl(`${environment.domainUrl}/my-profile`)
  }

  openChangePassword () {
    this.showProfileDropdown = false
    this.router.navigate(['/account-settings'])
  }

  openAccountSettings () {
    this.router.navigate(['/account-settings'])
  }

  signOut () {
    this.showProfileDropdown = false
    this.authService?.signOut()
  }
}
